// extracted by mini-css-extract-plugin
export default {"sidenav":"SideNav_sidenav__3e+lL","divider":"SideNav_divider__vcy74","spacer":"SideNav_spacer__tpwVI"};